import { createSlice } from '@reduxjs/toolkit'
import { getGamesList, getGamesSettings, getSpecificGame, updateGamesSettings, updateMultiGamesSettings } from 'redux-thunk/thunk/gameSettings.thunk'

const initialState = {
  games: null,
  settings: null,
  specificGame: null,
  multiGameSettings: null
}

const gamesSettingsSlice = createSlice({
  name: 'gameSettingsSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getGamesList.fulfilled, (state, action) => {
        const games = {}
        if (action?.payload?.rows) {
          games.count = action.payload.count
          games.rows = action.payload.rows
        }
        return {
          ...state,
          games
        }
      })
      .addCase(getGamesSettings.fulfilled, (state, action) => {
        return {
          ...state,
          settings: action.payload
        }
      })
      .addCase(updateGamesSettings.fulfilled, (state, action) => {
        return {
          ...state,
          settings: action.payload
        }
      })
      .addCase(getSpecificGame.fulfilled, (state, action) => {
        return {
          ...state,
          specificGame: action.payload
        }
      })
      .addCase(updateMultiGamesSettings.fulfilled, (state, action) => {
        return {
          ...state,
          multiGameSettings: action.payload
        }
      })
  }
})

export default gamesSettingsSlice.reducer
